import React from 'react';
import { Controller, Control } from 'react-hook-form';
import { useTranslation } from 'react-i18next';

import PhoneNumberInput from 'components/form/PhoneNumberInput';
import { PhoneNumberSettingEnum } from 'constants-whitelabel';
import { WhiteLabelType } from 'application-types';
import { FormData } from '../../OnboardingProfile/ProfileForm';

import styles from './index.scss';

const TRANSLATION_KEYS = {
  phoneLabel: 'web.onboarding.userProfile.phoneLabel',
  phnVerifyBtn: 'web.onboarding.userProfile.phnVerifyBtn',
  phnVerifyReqLabel: 'web.onboarding.userProfile.phnVerifyReqLabel',
  phoneVerified: 'web.onboarding.userProfile.phoneVerified',
  phoneValidationError: 'web.onboarding.userProfile.phoneValidationError',
  phoneVerificationInfo: 'web.onboarding.userProfile.phoneVerificationInfo',
};

type Props<T extends Record<string, any> = FormData> = {
  control: Control<FormData>;
  whitelabel: Pick<WhiteLabelType, 'settings'>;
  getErrorMessage: (field: keyof T) => string[] | null;
  phoneValidationError?: string | null;
};

export const ProfilePhoneNumberInput = <T extends Record<string, any> = FormData>({
  control,
  whitelabel,
  getErrorMessage,
  phoneValidationError,
}: Props<T>) => {
    const { t } = useTranslation();

  const isPhoneRequired = whitelabel.settings?.phoneConfig === PhoneNumberSettingEnum.REQUIRED;
  const isPhoneOptional = whitelabel.settings?.phoneConfig === PhoneNumberSettingEnum.OPTIONAL;
  const shouldShowPhoneInput = isPhoneRequired || isPhoneOptional;

 

  if (!shouldShowPhoneInput) {
    return null;
  }

  return (
    <div className={styles.phoneInputWrapper}>
      <Controller
        name="phone"
        control={control}
        rules={{
          required: isPhoneRequired,
        }}
        render={({ field: { onChange, value } }) => (
          <PhoneNumberInput
            className={styles.phoneInput}
            label="Mobile Number"
            value={value || ''}
            onChange={onChange}
            error={phoneValidationError ? [phoneValidationError] : (getErrorMessage('phone') ?? [])}
            isRequired={isPhoneRequired}
           
          />
        )}
      />
      {phoneValidationError && (
        <div className={styles.phoneValidationError}>
            {phoneValidationError}
        </div>
      )}
      <div className={styles.phoneVerificationInfo}>{t(TRANSLATION_KEYS.phoneVerificationInfo)}</div>
    </div>
  );
};
